import "util/print_debug";
import "vendors/segment";
import { renderWithContext } from "apps/root";
import VerifyRouter from "verify_portal/router";

renderWithContext(VerifyRouter);
